import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared QueryClient. All server state flows through TanStack Query —
 * never component state or Zustand.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
